const n = `<svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M3.029,0a.5.5,0,0,0-.465.316L1.141,4.467A.385.385,0,0,0,1.5,5H3.008a.25.25,0,0,1,.241.315L2.156,9.4A.5.5,0,0,0,3,9.853L8.769,3.442A.385.385,0,0,0,8.5,2.778H6.48a.25.25,0,0,1-.232-.343l.7-1.749A.5.5,0,0,0,6.484,0Z"
        fill="currentColor" stroke="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="0"></path>
</svg>`;
export {
  n as default
};
